import ActionAlert from "~/ui/ActionAlert";
import Button from "~/ui/Button";
import FieldError from "~/ui/FieldError";
import FormFieldsWrapper from "~/ui/FormFieldsWrapper";
import Label from "~/ui/Label";
import Link from "~/ui/Link";
import StarInput from "~/ui/StarInput";
import TextArea from "~/ui/TextArea";
import ROUTES from "~/kernel/routing/ROUTES";
import { Form, useActionData } from "@remix-run/react";
import type { ActionData } from "./route";
import useIsWorking from "~/kernel/server/useIsWorking";
import useTranslation from "~/kernel/internationalization/useTranslation";
import { CheckboxField } from "~/ui/CheckboxField";

export default function ReviewForm() {
  const actionData = useActionData<ActionData>();
  const isWorking = useIsWorking();
  const { t } = useTranslation();

  return (
    <Form method="post">
      <FormFieldsWrapper>
        <StarInput error={actionData?.errors?.score} required />
        <TextArea
          label={t("new.reviewText")}
          id="reviewText"
          error={actionData?.errors?.reviewText}
        />
        <div className="space-y-2">
          <div className="flex gap-2 items-center">
            <CheckboxField id="acceptsTermsOfUsage" />
            <Label
              id="acceptsTermsOfUsage"
              required
              label={
                <label
                  className="text-sm text-slate-500"
                  htmlFor="acceptsTermsOfUsage"
                >
                  {t("new.bySubmittingReview")}{" "}
                  <Link to={ROUTES.termsOfUsage.path()}>
                    {t("new.termsOfUsage")}
                  </Link>
                  .
                </label>
              }
            />
          </div>
          <FieldError error={actionData?.errors?.acceptsTermsOfUsage} />
        </div>
        <Button
          variant="primary"
          type="submit"
          children={t("new.submitButtonText")}
          loading={isWorking}
        />
        <ActionAlert actionData={actionData} />
      </FormFieldsWrapper>
    </Form>
  );
}
